export function target() {
  return ['Banner', 'BannerWithMenu'].includes(this.module);
}

export function migrate() {
  const banners = this.data.banners || [];
  // this is needed due to a bug on Header->BannerWithMenu migration,
  // where the banners were undefined.

  this.data.banners = banners.map(({ textPosition, ...banner }) => ({
    ...banner,
    textPosition: textPosition || 'Esquerda',
  }));
}
